// extracted by mini-css-extract-plugin
export default {"box":"styles_box__Xw+Ye","headerText":"styles_headerText__X3lQe"};